import { initializeApp } from "firebase/app"
import { initializeAuth, getReactNativePersistence } from "firebase/auth/react-native"
import AppConstants from "./AppConstants"
import AsyncStorage from "@react-native-async-storage/async-storage"

const app = initializeApp(AppConstants.firebaseConfig)
const auth = initializeAuth(app, { persistence: getReactNativePersistence(AsyncStorage) })

export { auth }
